export default __webpack_public_path__ + "static/media/cheesy.1906b404.png";